import React, {Component} from 'react'
import imagesPath from '../../config/imagesPath'

export default class Video extends Component {

    render() {
        return (
            <div className="container">
                <section id="services" className="services">
                    <div className="container" data-aos="fade-up">
                        <div className="section-titles">
                            <h3 className="heading_tow">Youtube Media</h3>
                        </div>
                    </div>
                </section>
                <div className="row">
                    <div className="col-sm-12 col-md-6 col-lg-4">
                        <div className="embed-responsive embed-responsive-16by9 mgb-20">
                            <iframe width="560" height="400" src={imagesPath.video5} frameBorder="0"
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"></iframe>
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-4">
                        <div className="embed-responsive embed-responsive-16by9 mgb-20">
                            <iframe width="560" height="400" src={imagesPath.video6} frameBorder="0"
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"></iframe>
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-4">
                        <div className="embed-responsive embed-responsive-16by9 mgb-20">
                            <iframe width="560" height="400" src={imagesPath.video7} frameBorder="0"
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"></iframe>
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-4">
                        <div className="embed-responsive embed-responsive-16by9 mgb-20">
                            <iframe width="560" height="315" src={imagesPath.video8} frameBorder="0"
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"></iframe>
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-4">
                        <div className="embed-responsive embed-responsive-16by9 mgb-20">
                            <iframe width="560" height="315" src={imagesPath.video9} frameBorder="0"
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"></iframe>
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-4">
                        <div className="embed-responsive embed-responsive-16by9 mgb-20">
                            <iframe width="560" height="315" src={imagesPath.video10} frameBorder="0"
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"></iframe>
                        </div>
                    </div>

                </div>

            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/media/Video.js